export default {
    data () {
        return {
            resettingList: false,
        };
    },

    methods: {
        resetMaintenanceRequestGroupToDefaults (settingsId, companyType, toggleConfirmation = false) {
            return new Promise((resolve, reject) => {
                this.resettingsList = true;
                App.patch(`/settings/maintenance/requests/${settingsId}/reset-to-defaults`, new AppForm({company_type: companyType}))
                .then(response => {
                    toastr.success(response);
                    if (toggleConfirmation) {
                        this.toggleShowResetConfirmation();
                    }
                    this.resettingsList = false;
                    resolve();
                })
                .catch(error => {
                    this.resettingsList = false;
                    toastr.error(error.message);
                    reject();
                });
            });
        },
    },
};